export default __webpack_public_path__ + "ui/assets/img/eye-open.svg";